function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import cn from 'classnames';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { Typography, Drawer, DropdownMenu, DropdownMenuItem, TextButton } from 'seagull';
import { Accounting } from "../../../types/api.model";
import { useStoreActions } from "../../../contexts";
import { TimeActivityCard } from "../TimeActivityCard/TimeActivityCard";
import { TimeActivityActions } from "../TimeActivityActions/TimeActivityActions";
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import { useOpenMapServicesModal } from "../../../integrations/Accounting/MapServicesModal/useOpenMapServicesModal";
import { getUnusedTimeActivities, handleAddAllTimeActivities as _handleAddAllTimeActivities, handleAddSingleTimeActivity as _handleAddSingleTimeActivity } from "../BillClientModal.utils";
import styles from "./TimeActivitiesDrawer.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TimeActivitiesDrawer = props => {
  const {
    open,
    itemsControl,
    serviceOptions,
    timeActivities,
    relationship,
    setRelationship,
    close,
    getValues
  } = props;
  const [selectedService, setSelectedService] = useState(serviceOptions[0]);
  const [servicesSelectorOpen, setServicesSelectorOpen] = useState(false);
  const {
    fetchQboTimeActivities
  } = useStoreActions();
  const handleTimeActivitiesServiceSelected = selectedOption => {
    setSelectedService(selectedOption);
    setServicesSelectorOpen(false);
  };
  const fullSelectedService = useMemo(() => relationship.services.find(s => s.id === selectedService.id), [relationship, selectedService]);
  const selectedServiceTimeActivities = useMemo(() => timeActivities.getTimeActivitiesForService(selectedService.id), [timeActivities, selectedService]);
  const {
    fullName: accountingName
  } = getAccountingDetails(Accounting.QBO);
  const items = getValues('items');
  const unusedTimeActivities = useMemo(() => getUnusedTimeActivities(items, selectedServiceTimeActivities), [items, selectedServiceTimeActivities]);
  return /*#__PURE__*/_jsx(Drawer, {
    PaperProps: {
      style: {
        position: 'absolute',
        width: 680
      }
    },
    variant: "persistent",
    open: open,
    headerClassName: styles.drawerHeader,
    header: /*#__PURE__*/_jsxs("div", {
      className: styles.timeActivitiesHeader,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "normal",
        children: "Billable Time"
      }), /*#__PURE__*/_jsx(DropdownMenu, {
        hAlign: "left",
        maxHeight: 200,
        onOpenChange: setServicesSelectorOpen,
        target: /*#__PURE__*/_jsxs("div", {
          className: styles.timeActivitiesServicesSelector,
          children: [/*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            ellipsis: true,
            skin: "primary",
            className: styles.timeActivitiesServiceName,
            "data-testid": "time-activities-service-name",
            children: selectedService.name
          }), servicesSelectorOpen ? /*#__PURE__*/_jsx(WideArrowUpward, {
            width: 20,
            height: 20,
            className: styles.arrowIcon
          }) : /*#__PURE__*/_jsx(WideArrowDownward, {
            width: 20,
            height: 20,
            className: cn(styles.arrowIcon, styles.arrowIconDown)
          })]
        }),
        children: serviceOptions.map(item => {
          const {
            id,
            name,
            costString
          } = item;
          const isSelected = selectedService.id === id;
          return /*#__PURE__*/_jsxs(DropdownMenuItem, {
            height: 56,
            skin: "primary",
            "data-testid": "time-activities-service-option-".concat(id),
            onClick: () => handleTimeActivitiesServiceSelected(item),
            selected: isSelected,
            children: [/*#__PURE__*/_jsx(Typography, {
              ellipsis: true,
              variant: "paragraph1",
              "data-testid": "option-".concat(id, "-title"),
              children: name
            }), /*#__PURE__*/_jsx(Typography, {
              ellipsis: true,
              variant: "paragraph1",
              skin: "secondary",
              children: costString
            })]
          }, id);
        })
      })]
    }),
    onClose: close,
    onCloseButtonClick: close,
    BackdropProps: {
      invisible: true
    },
    children: /*#__PURE__*/_jsxs("div", {
      "data-testid": "time-activities-side-panel",
      children: [/*#__PURE__*/_jsx(TimeActivityActions, {
        handleAddAllTimeActivities: () => {
          if (!fullSelectedService) return;
          _handleAddAllTimeActivities({
            itemsControl,
            timeActivities: selectedServiceTimeActivities,
            fullSelectedService,
            getValues
          });
        },
        showAddAll: !!(fullSelectedService !== null && fullSelectedService !== void 0 && fullSelectedService.integrations.qboIntegratedId()) && unusedTimeActivities.length > 0,
        relationshipId: relationship.id
      }), fullSelectedService !== null && fullSelectedService !== void 0 && fullSelectedService.integrations.qboIntegratedId() ? unusedTimeActivities.length ? unusedTimeActivities.map(timeActivity => /*#__PURE__*/_jsx(TimeActivityCard, {
        timeActivity: timeActivity,
        handleAddSingleTimeActivity: () => {
          if (!fullSelectedService) return;
          _handleAddSingleTimeActivity({
            timeActivity,
            itemsControl,
            fullSelectedService,
            getValues
          });
        }
      }, timeActivity.id)) : /*#__PURE__*/_jsx("div", {
        className: styles.timeActivitiesEmptyState,
        children: /*#__PURE__*/_jsxs(Typography, {
          "data-testid": "time-activities-empty-state",
          variant: "paragraph1",
          skin: "secondary",
          children: ["No billable time activities found for this service in ", accountingName]
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: styles.timeActivitiesEmptyState,
        children: /*#__PURE__*/_jsxs(Typography, {
          "data-testid": "time-activities-empty-state",
          variant: "paragraph1",
          skin: "secondary",
          children: ["Service is not mapped with ".concat(accountingName, ". "), fullSelectedService && /*#__PURE__*/_jsx(MapServiceMessage, {
            service: fullSelectedService,
            onRefresh: async _ref => {
              let {
                serviceTemplateId,
                accountingItemId
              } = _ref;
              const updatedServices = relationship.services.map(s => {
                if (s.serviceTemplateId === serviceTemplateId) {
                  const integrationQBO = s.integrations.setQboIntegratedId(accountingItemId);
                  return _objectSpread(_objectSpread({}, s), {}, {
                    integrations: integrationQBO
                  });
                }
                return s;
              });
              setRelationship(old => _objectSpread(_objectSpread({}, old), {}, {
                services: updatedServices
              }));
              await fetchQboTimeActivities(relationship.id);
            }
          })]
        })
      })]
    })
  });
};
export default TimeActivitiesDrawer;
const MapServiceMessage = _ref2 => {
  let {
    service,
    onRefresh
  } = _ref2;
  const serviceTemplateIds = getAccountingDetails(Accounting.QBO).policy.getServiceTemplateIdsFromServices([service]);
  const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, onRefresh);
  return /*#__PURE__*/_jsx(TextButton, {
    "data-testid": "map-service-button",
    underline: false,
    onClick: () => openMapServicesModal(Accounting.QBO),
    children: "Map service"
  });
};